import { SPAN_PAYMENT_LINK_REDIRECT_STORAGE_KEY } from '@features/reservation/constants/spanPaymentLink';

/** Remember, before leaving for PayNow, that the payment comes from the payment link — the return lands elsewhere. */
export const rememberSpanPaymentLinkRedirect = (): void => {
  sessionStorage.setItem(SPAN_PAYMENT_LINK_REDIRECT_STORAGE_KEY, '1');
};

/** Tell, once, whether the payment the gateway returns from was started from the payment link. */
export const takeSpanPaymentLinkRedirect = (): boolean => {
  const remembered = sessionStorage.getItem(SPAN_PAYMENT_LINK_REDIRECT_STORAGE_KEY) !== null;
  sessionStorage.removeItem(SPAN_PAYMENT_LINK_REDIRECT_STORAGE_KEY);
  return remembered;
};
